import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { useTranslation } from 'next-i18next'
// Methods
import handleCopyValue from '@/methods/handleCopyValue'

// Components
import Link from '@/components/common/Link'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

function SimpleHeader() {
  const { t } = useTranslation()

  const handleEmailClick = () => {
    handleCopyValue({ t, value: EXTERNAL_LINK.HKFEC_CONTACT_EMAIL })
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <div className={cx('header__start')}>
          <Link url={EXTERNAL_LINK.HKFEC_OFFICIAL_SITE} isOpen>
            <div className={cx('header-logo')}>
              <Image src='/images/hkfec-logo-hkflc.png' width={210} height={70} alt='HKFLC' />
            </div>
          </Link>
        </div>

        <div className={cx('header__actions')}>
          <a
            className={cx('header__action', 'header__action--com360')}
            href={EXTERNAL_LINK.HKFEC_COM360_SITE}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='COM360'
          >
            <Image src='/images/hkfec-com360.png' width={100} height={40} alt='' />
          </a>
          <button type='button' className={cx('header__action')} onClick={handleEmailClick} aria-label='Email'>
            <Image src='/images/hkfec-email-icon.png' width={28} height={28} alt='' />
          </button>
          <a className={cx('header__action')} href={EXTERNAL_LINK.HKFEC_FACEBOOK} target='_blank' rel='noopener noreferrer' aria-label='Facebook'>
            <Image src='/images/hkfec-facebook-icon.png' width={28} height={28} alt='' />
          </a>
          <a className={cx('header__action')} href={EXTERNAL_LINK.HKFEC_LINKEDIN} target='_blank' rel='noopener noreferrer' aria-label='LinkedIn'>
            <Image src='/images/hkfec-linkedin-icon.png' width={28} height={28} alt='' />
          </a>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
